import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "deposit section--mini section screen-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "deposit__title" }, "Recieve USDT", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "deposit__hint" }, "The commission is charged from the deposit. We charge a 8 usdt + 9% fee on deposit.", -1)
const _hoisted_5 = { class: "deposit__address" }
const _hoisted_6 = { class: "deposit__footer" }

import "./TopUpView.scss";
import Button from "@/components/Button/Button.vue";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import ModalLayout from "@/layouts/ModalLayout/ModalLayout.vue";
import {computed, onMounted, ref} from "vue";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import {storeToRefs} from "pinia";
import {useUserStore} from "@/stores/userStore";
import {useAlertsStore} from "@/stores/alertsStore";
import copy from "copy-to-clipboard";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopUpView',
  setup(__props) {

let router = useRouter();

let {api} = useApiStore();
let userStore = useUserStore();
let alertsStore = useAlertsStore();

let {me} = storeToRefs(userStore);

let qr = ref<string|null>(null);

function copyWallet(){
	copy(me.value!.wallet);

	alertsStore.pushSuccess('Was copied to clipboard!');
}

async function scan(){

	router.back();

	await api.scanDeposits();

	alertsStore.pushSuccess('Wait 5 minutes for scan your deposit');

}

onMounted(async () => {

	qr.value = await api.getDepositQr();

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalLayout, {
    title: "Deposit",
    back: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "deposit__qr",
          innerHTML: _unref(qr)
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(me).wallet), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Button, {
            color: "dark",
            type: "button",
            onClick: copyWallet
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                name: "copy",
                size: 1.1
              }),
              _createTextVNode(" Copy ")
            ]),
            _: 1
          }),
          _createVNode(Button, {
            color: "brand",
            onClick: scan
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, {
                name: "check",
                size: 1.5
              }),
              _createTextVNode(" Paid ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})